export default {"src":"/_next/static/media/analytics-and-insigts.3d8b4d3c.svg","height":151,"width":151,"blurWidth":0,"blurHeight":0};